import React, { CSSProperties } from 'react'
import { appConfig } from '@/config/app.ts'
import { currencyFn } from '@/core/components/presentationStandards/currencyFn.tsx'
import { Box } from '@mui/material'

interface Props {
  field?: string | number | null
  align?: CSSProperties['textAlign']
  currency?: string
  currencyToRight?: boolean
  showPositiveSign?: boolean
  style?: CSSProperties
  component?: React.ElementType
}

const Currency = ({
  field,
  align,
  currency,
  currencyToRight,
  showPositiveSign,
  style,
  component
}: Props) => {
  return (
    <Box
      component={component || 'div'}
      style={{ textAlign: align || appConfig.currencyAlign, ...style }}
    >
      {currencyFn({
        value: field,
        currency,
        currencyToRight,
        showPositiveSign
      })}
    </Box>
  )
}

export default Currency
